import { createAction } from '@reduxjs/toolkit';

const ACTION_PREFIX = 'vetting';

export const submitVetting = createAction(`${ACTION_PREFIX}/SUBMIT_VETTING`);
export const submitVettingSucceeded = createAction(`${ACTION_PREFIX}/SUBMIT_VETTING_SUCCEEDED`);
export const submitVettingFailed = createAction(`${ACTION_PREFIX}/SUBMIT_VETTING_FAILED`);

export const submitVettingStep1 = createAction(`${ACTION_PREFIX}/SUBMIT_VETTING_STEP_1`);
export const submitVettingStep2 = createAction(`${ACTION_PREFIX}/SUBMIT_VETTING_STEP_2`);
export const submitVettingStep3 = createAction(`${ACTION_PREFIX}/SUBMIT_VETTING_STEP_3`);

export const updateFields = createAction(`${ACTION_PREFIX}/UPDATE_FIELDS`);

export const getMoreInfo = createAction(`${ACTION_PREFIX}/GET_MORE_INFO`);

export const updateStage = createAction(`${ACTION_PREFIX}/UPDATE_STAGE`);

export const agreeToTerms = createAction(`${ACTION_PREFIX}/AGREE_TO_TERMS`);

export const resendConfirmationEmail = createAction(`${ACTION_PREFIX}/RESEND_CONFIRMATION_EMAIL`);
export const resendConfirmationEmailSucceeded = createAction(`${ACTION_PREFIX}/RESEND_CONFIRMATION_EMAIL_SUCCEEDED`);
export const resendConfirmationEmailFailed = createAction(`${ACTION_PREFIX}/RESEND_CONFIRMATION_EMAIL_FAILED`);

export const VettingActions = {
  submitVetting,
  submitVettingSucceeded,
  submitVettingFailed,

  resendConfirmationEmail,
  resendConfirmationEmailSucceeded,
  resendConfirmationEmailFailed,

  getMoreInfo,

  submitVettingStep1,
  submitVettingStep2,
  submitVettingStep3,

  updateFields,

  updateStage,
  agreeToTerms,
};
